/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embedding_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure how this space automatically embeds files." |
*
* @param {Spaces_Wizard_Step3_Embedding_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embedding_description = /** @type {((inputs?: Spaces_Wizard_Step3_Embedding_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embedding_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfiguriere, wie dieser Space Dateien automatisch embedden soll.")
	return /** @type {LocalizedString} */ ("Configure how this space automatically embeds files.")
});